import React, { useEffect, useState } from "react";
import { Drawer, theme } from "antd";
import "./Nav.css";
import logoImg1 from "../../Assets/PM-Youth-green-white-flag02.png";
import logoImg2 from "../../Assets/logo_icon.png";

const Nav = () => {
  const [isNavbarFixed, setIsNavbarFixed] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setIsNavbarFixed(window.scrollY >= 500);
    }
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <nav className={isNavbarFixed ? "fixed-navbar" : ""}>
        <img src={logoImg1} alt="logo-img1" className="logo-img1" />
        <img src={logoImg2} alt="logo-img" className="logo-img2" />
        <div className="nav-right-card">
          <button>
            <span class="material-symbols-outlined">trending_up</span>
            <h1>
            ANALYTICS
            </h1>
          </button>
          <span class="material-symbols-outlined menu" onClick={showDrawer}>
            menu
          </span>
        </div>
      </nav>
      <Drawer placement="left" onClose={onClose} open={open} width={"100%"}>
        <div className="mobile-nav">
          <ul>
            <li>
              <a href="#">Features</a>
            </li>
            <li>
              <a href="#">About</a>
            </li>
            <li>
              <a href="#">Pricing</a>
            </li>
            <li>
              <a href="#">Reviews</a>
            </li>
            <li>
              <a href="#">Contact</a>
            </li>
          </ul>
        </div>
      </Drawer>
    </>
  );
};

export default Nav;
